import { initializeApp, type FirebaseApp } from 'firebase/app'
import { getAuth, type Auth } from 'firebase/auth'
import { readEnv } from '@/lib/env'
import { setApiBaseUrl } from '@/lib/api-client'

let app: FirebaseApp | null = null
let auth: Auth | null = null

export interface FirebaseInitResult {
  ok: boolean
  missing: string[]
}

export function initFirebase(): FirebaseInitResult {
  if (auth) return { ok: true, missing: [] }

  const { env, missing } = readEnv()
  if (!env) {
    // In development we want a loud error to catch misconfiguration early.
    if (import.meta.env.DEV) {
      throw new Error(
        `Firebase admin no configurado. Faltan variables: ${missing.join(', ')}`,
      )
    }
    return { ok: false, missing }
  }

  app = initializeApp({
    apiKey: env.firebase.apiKey,
    authDomain: env.firebase.authDomain,
    projectId: env.firebase.projectId,
    appId: env.firebase.appId,
  })
  auth = getAuth(app)
  setApiBaseUrl(env.apiBaseUrl)
  return { ok: true, missing: [] }
}

export function getFirebaseAuth(): Auth {
  if (!auth) {
    throw new Error('Firebase auth no inicializado. Llamar initFirebase primero.')
  }
  return auth
}
